import { Button } from 'antd';
import { useTranslation } from 'react-i18next';

interface ClearFilter {
  disabled?: boolean;
  onClick(...args: unknown[]): unknown;
  title?: string;
}

const ClearFilter = ({ disabled, onClick, title }: ClearFilter): JSX.Element => {
  const { t } = useTranslation('Vindoc');
  title = title || t('Clear Filter');

  return (
    <div className="filter-items flex items-end">
      <Button size="small" className="filter-btn" disabled={disabled} onClick={onClick}>
        {title}
      </Button>
    </div>
  );
};

export default ClearFilter;
